<div
  *ngIf="!is_list_running"
  class="sp-width__full sp-min-height__full sp-column">
  <app-pending-invitations-data-table
    *ngIf="invitations?.length"
    [invitations]="invitations || []"
    class="sp-width__full"
    (refresh)="refresh.emit()"
    (scrolledToEnd)="onScrollEnd()"></app-pending-invitations-data-table>
</div>

<app-loading *ngIf="is_list_running"> </app-loading>
